import axios from 'axios';
import { aliasesOf } from '../data/delegationAliases';

export function confirmedPosition(latitude, longitude) {
  if ([latitude, longitude].some(value => !['string', 'number'].includes(typeof value) || String(value).trim() === '')) return null;
  const lat = Number(latitude), lng = Number(longitude);
  if (!Number.isFinite(lat) || !Number.isFinite(lng) || Math.abs(lat) > 90 || Math.abs(lng) > 180 || (lat === 0 && lng === 0)) return null;
  if ([[34.802075, 9.055876], [33.8869, 9.5375]].some(([x, y]) => Math.abs(lat - x) < 1e-7 && Math.abs(lng - y) < 1e-7)) return null;
  return [lat, lng];
}

export async function searchAddress({ Adresse = '', Delegation, Ville }, { signal } = {}) {
  if (!Ville?.trim() || !Delegation?.trim()) return null;
  // Search-only spellings (e.g. Zaouia for Zawiya) are tried after the catalog name, as approximate areas.
  const areas = [Delegation, ...aliasesOf(Ville.trim(), Delegation.trim())].map(name => `${name.trim()}, ${Ville.trim()}, Tunisie`);
  const queries = Adresse.trim() ? [`${Adresse.trim()}, ${areas[0]}`, ...areas] : areas;
  for (const query of queries) {
    const response = await axios.get(`https://nominatim.openstreetmap.org/search?q=${encodeURIComponent(query)}&format=json&addressdetails=1&limit=1&countrycodes=tn`, {
      headers: { 'Accept-Language': 'fr' }, timeout: 10000, signal,
    });
    const result = response.data?.[0];
    const position = result && confirmedPosition(result.lat, result.lon);
    if (position) return { position, approximate: areas.includes(query) };
  }
  return null;
}
